import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import vuetify from './plugins/vuetify';
import MultiFiltersPlugin from './plugins/MultiFilters'
import Croppa from 'vue-croppa';
import Amplify from 'aws-amplify'
import VueMoment from 'vue-moment'


Amplify.configure({
  Auth: {
    userPoolId: "us-east-1_aTBbpIxpF",
    region: "us-east-1",
    // identityPoolId: 'us-east-1:587c0004-2cd7-4778-851f-595739bb0c5b',
    userPoolWebClientId: "4v1ab2ds46f6994jt1spvra6qs"
  }
})
Vue.config.productionTip = false
Vue.use(MultiFiltersPlugin);
Vue.use(Croppa);
Vue.use(VueMoment);

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
